import * as actionCreatorFactory from "typescript-fsa";

import { PaginationResult, HttpStateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { Bundle, UploadNormalisedEntities } from "../models";

export type BundlesResult = NormalisedResult<number[], UploadNormalisedEntities>;

const actionCreator = actionCreatorFactory.default();

// Bundles index
export const requestBundlesIndex = actionCreator<{}>(actionTypes.BUNDLE_INDEX_REQUEST);
export const bundlesIndexSuccess = actionCreator<[PaginationResult, BundlesResult]>(
    actionTypes.BUNDLE_INDEX_SUCCESS,
);
export const bundlesIndexFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_INDEX_FAILURE);

// Bundles store
export const requestBundlesStore = actionCreator<Bundle>(actionTypes.BUNDLE_STORE_REQUEST);
export const bundlesStoreSuccess = actionCreator<number>(actionTypes.BUNDLE_STORE_SUCCESS);
export const bundlesStoreFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_STORE_FAILURE);

// Bundles show
export const requestBundlesShow = actionCreator<number>(actionTypes.BUNDLE_SHOW_REQUEST);
export const bundlesShowSuccess = actionCreator<NormalisedResult<number, UploadNormalisedEntities>>(
    actionTypes.BUNDLE_SHOW_SUCCESS,
);
export const bundlesShowFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_SHOW_FAILURE);

// Bundles update
export const requestBundlesUpdate = actionCreator<Bundle>(actionTypes.BUNDLE_UPDATE_REQUEST);
export const bundlesUpdateSuccess = actionCreator<number>(actionTypes.BUNDLE_UPDATE_SUCCESS);
export const bundlesUpdateFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_UPDATE_FAILURE);

// Bundles store album
export const requestBundlesStoreAlbum = actionCreator<number>(actionTypes.BUNDLE_STORE_ALBUM_REQUEST);
export const bundlesStoreAlbumSuccess = actionCreator<[number, number]>(actionTypes.BUNDLE_STORE_ALBUM_SUCCESS);
export const bundlesStoreAlbumFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_STORE_ALBUM_FAILURE);

// Bundles upload zip
export const requestBundlesUploadZip = actionCreator<number>(actionTypes.BUNDLE_UPLOAD_ZIP_REQUEST);
export const bundlesUploadZipSuccess = actionCreator<number>(actionTypes.BUNDLE_UPLOAD_ZIP_SUCCESS);
export const bundlesUploadZipFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_UPLOAD_ZIP_FAILURE);

// Bundles complete
export const requestBundlesComplete = actionCreator<number>(actionTypes.BUNDLE_COMPLETE_REQUEST);
export const bundlesCompleteSuccess = actionCreator<number>(actionTypes.BUNDLE_COMPLETE_SUCCESS);
export const bundlesCompleteFailure = actionCreator<HttpStateError>(actionTypes.BUNDLE_COMPLETE_FAILURE);
